<template lang="pug">
  .sidebar(:data-color='activeColor')
    .logo
      a(href='#')
        .logo-img
          img(:src='imgLogo', alt='')
    .sidebar-wrapper
      slot(name='content')
        md-list.nav(id="navlist")
          sidebar-link(to='/dashboard')
            md-icon dashboard
            p Home
          md-list-item(md-expand class="multi-sidebar" :md-expanded.sync='trading' @click="expandTab('trading')")
            md-icon trending_up
            p Trading
            md-list(slot="md-expand")
              sidebar-link(to='vote') 
                p Vote
              sidebar-link(to='positions')
                p Manage Positions
              sidebar-link(to='rankings')
                p Rankings
          md-list-item(md-expand class="multi-sidebar" :md-expanded.sync='groups' @click="expandTab('groups')")
            md-icon group
            p Groups
            md-list(slot="md-expand")
              sidebar-link(to='analyst_groups') 
                p Analyst Group
              sidebar-link(to='industry_funds')
                p Industry Funds
              sidebar-link(to='pitch_results' v-if="this.$store.state.user.is_internal")
                p Pitch Result
          md-list-item(md-expand class="multi-sidebar" :md-expanded.sync='resources' @click="expandTab('resources')")
            md-icon library_books
            p Resources
            md-list(slot="md-expand")
              sidebar-link(v-if="this.$store.state.isPaid" to='/box')
                p Box
              sidebar-link(v-else to='/box-preview')
                p Box
          md-list-item(md-expand class="multi-sidebar" :md-expanded.sync='events' @click="expandTab('events')")
            md-icon calendar_today
            p Events
            md-list(slot="md-expand")
              sidebar-link(to='/meetings')
                p Meetings
              sidebar-link(to='/calendar')
                p Calendar
          sidebar-link(to='/user')
            md-icon person
            p Account
</template>
<script>
import SidebarLink from "./SidebarLink.vue";

export default {
  components: {
    SidebarLink
  },
  data() {
    return {
      trading: false,
      resources: false,
      events: false,
      groups: false,
      user: null,
    }
  },
  props: {
    imgLogo: {
      type: String,
      default: require("@/assets/img/usit-logo.png")
    },
    activeColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  mounted() {
    var paths = document.getElementById('navlist').getElementsByTagName('path');
    for(var i = 0; i < paths.length; i += 2){
      paths[i].style.fill = "white";
    }
  },
  created() {
    this.$bus.$on('collapseNav', () => {
      this.trading = this.internal = this.events = this.resources = false;
    });
    this.user = this.$store.state.user;
  },
  methods: {
    expandTab(tabName) {
      Array.from(['groups', 'trading', 'resources', 'events']).forEach((val) => {
        if (val != tabName) {
          this[val] = false;
        }
      });
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}

.logo {
  max-width: 240px;
}
.logo-img {
  width: 46%;
  margin-left: 27%;
}
.sidebar {
  background: rgba(53, 53, 53, 0.651);
  overflow-y: hidden;
}

.multi-sidebar {
  margin: 10px 15px 0;
  color: white;
}
.multi-sidebar p {
  color: white;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarPlugin/SideBar.vue